import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to make ethical decisions.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Ethics. Standards of right and wrong. Rules. Guidelines
                                                suggesting what you ought to do. It
                                                seems straightforward. And yet, ask people from different
                                                cultures and backgrounds what an
                                                ethical decision actually means and you could hear some very
                                                different judgements.</p>
                                            <div className="border_subtitle">How do we make ethical
                                                decisions?
                                            </div>
                                            <p>Sometimes the issues we face are not clearly black or white,
                                                so we have to make a judgement
                                                call. Research conducted into ethical decision making has
                                                revealed some fascinating cross-cultural
                                                differences.</p>

                                            <div className="lightgreencontentbg space-pad">

                                                <div className="border_subtitle">A bribe or incentive?</div>
                                                <p>In 2004, researchers<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>1</sup></a> examining
                                                    culture and ethics analysed data from the World Values
                                                    Survey databank. They looked at the responses of 3,450
                                                    managers from 28 different
                                                    countries to justify ethically suspect behaviours, such
                                                    as whether to accept bribes in the
                                                    course of working duties. </p>
                                                <p>Their analysis pointed to several factors that were
                                                    predictive of accepting suspect
                                                    behaviours. For individuals, youth and rejection of
                                                    religion were the strongest predictors; at
                                                    a national level, poor schooling and high
                                                    industrialisation were strongest. They further
                                                    tested these predictors and identified that many
                                                    students from ‘collectivist’ societies (i.e.
                                                    those cultures in which identity is more strongly
                                                    defined by long-lasting group membership)
                                                    were far more willing to offer and accept bribes, as
                                                    this was part of ‘oiling the wheels’ of
                                                    long-term working relationships and being part of an
                                                    established group.</p>
                                                <p>So while some cultures frown heavily on payments in the
                                                    form of bribes, others may see
                                                    them as a natural and regular process in establishing
                                                    working partnerships. So who is less
                                                    or more ‘ethical’ in approach?</p>

                                            </div>


                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}